import { FormFeedback, InputWrapper, Toggle } from "@certn/cascadia-react";
import { useField } from "formik";
import { useTranslation } from "react-i18next";

export function DisableWebhookField() {
  const [field, meta, helpers] = useField("is_active");
  const { t } = useTranslation();

  return (
    <InputWrapper span="auto">
      <Toggle
        isSelected={!field.value}
        onChange={(newValue) => helpers.setValue(!newValue)}
        testID="disable-webhook-active"
      >
        {t("Disable this webhook")}
      </Toggle>
      <FormFeedback>{meta.touched && meta.error}</FormFeedback>
    </InputWrapper>
  );
}
